module.exports = __webpack_public_path__ + "img/taobao.9f2bed40.png";